import React, { useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/mergingListAction";
import * as uiHelpers from "../MergingListUIHelpers";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  toastOption,
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { useMergingListUIContext } from "../MergingListUIContext";
import { RoleChecker } from "../../../../RoleChecker";
import DeleteModal from "../DeleteModal/DeleteModal";
import { toast } from "react-toastify";
// import { ToastContainer } from 'react-toastify';

const MergingListTable = (props) => {
  // MergingList UI Context
  const mergingListUIContext = useMergingListUIContext();
  const mergingListUIProps = useMemo(() => {
    return {
      queryParams: mergingListUIContext.queryParams,
      setQueryParams: mergingListUIContext.setQueryParams,
      openEditMergingListPage: mergingListUIContext.openEditMergingListPage,
    };
  }, [mergingListUIContext]);

  // Getting curret state of mergingList list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.mergingList }),
    shallowEqual
  );

  // * MODAL
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentMergingList, setCurrentMergingList] = useState({});
  const deleteMergingList = () => {
    dispatch(actions.deleteMergingList(currentMergingList.uuid)).then((res) => {
      toast.success(res.message, toastOption);
      setDeleteModal(false);
      setCurrentMergingList({});
      dispatch(actions.fetchMergingLists(mergingListUIProps.queryParams));
    });
  };

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(actions.fetchMergingLists(mergingListUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mergingListUIProps.queryParams, dispatch]);

  const allowEdit = RoleChecker("Edit", "access_role");

  // Table columns
  const columns = [
    {
      dataField: "donation.donation_hid",
      text: "No Donasi",
      sort: true,
    },
    {
      dataField: "donation.donor.name",
      text: "Email",
      sort: true,
    },
    {
      dataField: "thk_livestock_name",
      text: "Hewan",
      sort: true,
    },
    {
      dataField: "name_1",
      text: "Atas Nama",
      sort: true,
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditMergingListPage: mergingListUIProps.openEditMergingListPage,
        allowEdit,
        setCurrentMergingList,
        setDeleteModal,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: mergingListUIProps.queryParams.pageSize,
    page: mergingListUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onHide={() => {
          setDeleteModal(false);
          setCurrentMergingList({});
        }}
        onClick={deleteMergingList}
        title="Hapus Mitra"
        content={`Apakah kamu yakin ingin menghapus mitra ${currentMergingList.name}?`}
      />
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  mergingListUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default MergingListTable;
